<template>
  <div class="card">
    <p class="tips">将【{{tagname}}】内选择的用户移动至以下标签内</p>
    <el-autocomplete
      class="inline-input"
      v-model="tags"
      value-key="name"
      size="small"
      :fetch-suggestions="querySearch"
      placeholder="请输入内容"
      @select="handleSelect"
    ></el-autocomplete>
    <el-button class="tag-btn" type="info" size="small" @click="handlerCencel">取消</el-button>
    <el-button class="tag-btn" type="primary" @click="handlerConfirm" size="small">确认</el-button>
  </div>
</template>

<script>
export default {
  name: 'TagListMove',
  props: {
    id: {
      type: [Number, String],
      default: 0,
    },
    tagname: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tags: '',
      datalist: [],
      select: {},
    };
  },
  watch: {
    tags(val, oldval) {},
  },

  methods: {
    handlerCencel() {
      this.select = {};
      this.tags = '';
      this.$emit('close');
    },

    handlerConfirm() {
      if (!this.select.name) {
        this.$message.error('请先选择标签');
        return false;
      }
      this.$emit('select', this.select);
    },

    querySearch(queryString, cb) {
      var restaurants = this.filter(queryString);
      cb(restaurants);
    },

    filter(key) {
      let data = this.datalist;
      if (!key) {
        return data;
      }
      let ret = [];
      data.forEach(item => {
        if (item.name.toLowerCase().indexOf(key.toLowerCase()) >= 0) {
          ret.push(item);
        }
      });
      return ret;
    },
    handleSelect(item) {
      this.select = item;
    },
    async getTags(key) {
      let res = await this.$http.get(`/api/${this.id}/custom-tags`, {
        params: {
          key: key || '',
        },
      });
      let ret = [];
      res.forEach(item => {
        ret.push(...item.customTags);
      });

      let result = [];
      ret.forEach(item => {
        if (this.tagname != item.name) {
          result.push(item);
        }
      });

      this.datalist = result;
    },
  },

  created() {
    this.getTags();
  },
};
</script>

<style lang="scss" scoped>
.crad {
}
.inline-input {
  margin: 15px 0;
  width: 100%;
}
.tag-btn {
  padding: 0 20px;
  height: 30px;
  border-radius: 4px;
}
</style>
